import { logUsage } from 'owa-analytics';
import { lazyGetGroupInfo } from 'owa-readwrite-recipient-well';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import GetGroupResponse from 'owa-service/lib/contract/GetGroupResponse';
import { SharingTipRecipientInfo } from 'owa-sharing-data';
import { trace } from 'owa-trace';
import {
    lazySetRecipientExpansionStatus,
    lazySetMembersToRecipientViewState,
} from 'owa-recipient-common';
import { RecipientMemberInfo } from 'owa-recipient-types/lib/types/RecipientMemberInfo';
import { RecipientExpansionStatus } from 'owa-recipient-types/lib/types/RecipientExpansionStatus';

export async function expandAndSetRecipientViewState(distributionList: SharingTipRecipientInfo) {
    trace.info('RecipientPermission: expandAndSetRecipientViewState');
    const getGroupInfo = await lazyGetGroupInfo.import();
    const persona = distributionList.recipient.persona;
    const emailAddress = distributionList.recipient.persona.EmailAddress;
    const emailAddressWrapper: EmailAddressWrapper = {
        EmailAddress: emailAddress.EmailAddress,
        Name: emailAddress.Name,
        MailboxType: emailAddress.MailboxType,
        RoutingType: emailAddress.RoutingType,
    };
    const setRecipientExpansionStatus = await lazySetRecipientExpansionStatus.import();
    try {
        setRecipientExpansionStatus(
            distributionList.recipient,
            RecipientExpansionStatus.InProgress
        );
        const response: GetGroupResponse = await getGroupInfo(
            persona.PersonaId,
            persona.ADObjectId,
            emailAddressWrapper,
            100 /* MaxEntriesReturned */,
            true /* ShouldUseDeepExpansion */
        );

        if (response?.Members) {
            let hasGroupOrDLMember: boolean = false;
            const members: RecipientMemberInfo[] = [];
            response.Members.forEach(function (member) {
                let recipientMemberInfo;
                switch (member.PersonaTypeString) {
                    case 'DistributionList':
                    case 'ImplicitGroup':
                    case 'ExplicitGroup':
                    case 'ModernGroup':
                        // add datapoint for this
                        hasGroupOrDLMember = true;
                        recipientMemberInfo = {
                            emailAddress: member.EmailAddress.EmailAddress,
                            displayName: member.DisplayName,
                            personaTypeString: member.PersonaTypeString,
                        };
                        break;
                    case 'Person':
                    case 'Guest':
                        recipientMemberInfo = {
                            emailAddress: member.EmailAddress.EmailAddress,
                            displayName: member.DisplayName,
                            personaTypeString: member.PersonaTypeString,
                        };
                        break;
                    default:
                        // Filter out Room, Place, Booking, Unknown
                        trace.error(
                            'RecipientExpansionIgnoredPersonaType: ' + member.PersonaTypeString
                        );
                        break;
                }
                if (recipientMemberInfo) {
                    members.push(recipientMemberInfo);
                }
            });

            const setMembersToRecipientViewState = await lazySetMembersToRecipientViewState.import();
            logUsage('SmallDLExpansionSucceess', [hasGroupOrDLMember]);
            setRecipientExpansionStatus(
                distributionList.recipient,
                hasGroupOrDLMember
                    ? RecipientExpansionStatus.SucceededWithDLOrGroupMembers
                    : RecipientExpansionStatus.SucceededWithoutDLOrGroupMembers
            );
            setMembersToRecipientViewState(distributionList.recipient, members);
            return;
        }
    } catch (error) {
        logUsage('SmallDLExpansionFailure', [error.message]);
    }

    setRecipientExpansionStatus(distributionList.recipient, RecipientExpansionStatus.Failed);
    return;
}
